import React from 'react';
import '/Users/jilin/projects/antd/rc-dialog/docs/demo/bootstrap.md?watch=parent';
import * as docs_demo_bootstrap_demo_bootstrap_deps_1 from 'react';
import * as docs_demo_bootstrap_demo_bootstrap_deps_2 from 'rc-dialog';
import * as docs_demo_bootstrap_demo_bootstrap_deps_3 from 'bootstrap/dist/css/bootstrap.css';
import * as docs_demo_bootstrap_demo_bootstrap_deps_4 from '/Users/jilin/projects/antd/rc-dialog/assets/bootstrap.less';
export const demos = {
  'docs-demo-bootstrap-demo-bootstrap': {
    component: React.memo(React.lazy(() => import( /* webpackChunkName: "demos" */ '/Users/jilin/projects/antd/rc-dialog/docs/examples/bootstrap.tsx?techStack=react'))),
    asset: {
  "type": "BLOCK",
  "id": "docs-demo-bootstrap-demo-bootstrap",
  "refAtomIds": [],
  "dependencies": {
    "index.tsx": {
      "type": "FILE",
      "value": require('/Users/jilin/projects/antd/rc-dialog/docs/examples/bootstrap.tsx?dumi-raw').default
    },
    "react": {
      "type": "NPM",
      "value": "18.3.1"
    },
    "@rc-component/dialog": {
      "type": "NPM",
      "value": "1.0.1"
    },
    "bootstrap": {
      "type": "NPM",
      "value": "4.6.2"
    },
    "../../assets/bootstrap.less": {
      "type": "FILE",
      "value": require('/Users/jilin/projects/antd/rc-dialog/assets/bootstrap.less?dumi-raw').default
    }
  },
  "entry": "index.tsx"
},
    context: {
  "../../assets/bootstrap.less": docs_demo_bootstrap_demo_bootstrap_deps_4,
  "react": docs_demo_bootstrap_demo_bootstrap_deps_1,
  "rc-dialog": docs_demo_bootstrap_demo_bootstrap_deps_2,
  "bootstrap/dist/css/bootstrap.css": docs_demo_bootstrap_demo_bootstrap_deps_3,
  "/Users/jilin/projects/antd/rc-dialog/assets/bootstrap.less": docs_demo_bootstrap_demo_bootstrap_deps_4
},
    renderOpts: {
          
          compile: async (...args) => {
            return (await import('/Users/jilin/projects/antd/rc-dialog/node_modules/_dumi@2.4.17@dumi/dist/client/misc/reactDemoCompiler.js')).default(...args);
          },
        },
  },
};